import React, { useEffect } from 'react'
import HubspotForm from 'react-hubspot-form';
import useStateRef from 'react-usestateref';

const HubSpotPluginForm = () => {

    const [portalId, setPortalId, portalIdRef] = useStateRef("44059706");
    const [formId, setFormId, formIdref] = useStateRef("1a35fe82-646c-4770-99e5-c70883527d20");
    const [region, setRegion, regionref] = useStateRef("na1");
    useEffect(()=>{

        var searchParam = window.location.search
        if(searchParam){
            console.log("searchParam",searchParam);
            let params = new URLSearchParams(searchParam);
            console.log("params",params);
            var portalId = params.get("portalId");
            var formId = params.get("formId");
            var region = params.get("region");
            setPortalId(portalId)
            setFormId(formId)
            setRegion(region)
        }

    },[])
    return (
        <HubspotForm
            portalId={portalIdRef.current}
            formId={formIdref.current}
            region={regionref.current}
            onSubmit={() => console.log('Submit!')}
        />
    )
}

export default HubSpotPluginForm